<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: 'welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>推荐码管理</el-breadcrumb-item>
      <el-breadcrumb-item>推荐码列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <!-- 检索与生成 -->
      <div class="search-wrapper">
        <div class="search-toggle" @click="toggleSearch" v-show="isMobile">
          <i :class="isSearchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          <span>{{ isSearchExpanded ? '收起筛选' : '展开筛选' }}</span>
        </div>
        <div class="search-content" v-show="!isMobile || isSearchExpanded" :class="{ 'search-content-mobile': isMobile }">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input
                placeholder="请输入推荐码"
                v-model="searchQuery.code"
                clearable
                @clear="handleSearch"
                size="medium"
              >
                <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
              </el-input>
            </el-col>
            <el-col :span="8">
              <el-input
                placeholder="请输入推荐人或机构"
                v-model="searchQuery.referrer_name"
                clearable
                @clear="handleSearch"
                size="medium"
              >
                <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
              </el-input>
            </el-col>
            <el-col :span="5">
              <el-select
                v-model.number="searchQuery.type"
                placeholder="请选择类型"
                clearable
                size="medium"
                style="width: 100%;"
                @change="handleSearch"
              >
                <el-option label="个人" :value="1"></el-option>
                <el-option label="机构" :value="2"></el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="openAddDialog" size="medium">创建推荐码</el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="table-scroll-wrapper">
      <el-table :data="inviteCodeList" style="width:100%; margin-top:20px" border stripe row-key="referral_code_id">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="expand-content">
              <!-- 基本信息 -->
              <div class="basic-info" v-if="props.row.remark || getCreatorName(props.row) || props.row.created_at">
                <div class="info-left">
                  <span v-if="props.row.phone" class="info-text">手机号：{{ props.row.phone }}</span>
                  <span v-if="props.row.remark" class="info-text">备注：{{ props.row.remark }}</span>
                </div>
                <div class="info-right">
                  <span v-if="getCreatorName(props.row)" class="info-text">创建人：{{ getCreatorName(props.row) }}</span>
                  <span v-if="props.row.created_at" class="info-text">创建时间：{{ formatDateTime(props.row.created_at) }}</span>
                </div>
              </div>
              <!-- 被邀请人列表 -->
              <div class="invited-list">
                <div class="list-title">被邀请人列表（共 {{ props.row.count || 0 }} 人）</div>
                <div class="invited-cards" v-if="props.row.referred_users && props.row.referred_users.length">
                  <div class="invited-card" v-for="(user, index) in props.row.referred_users" :key="index" @click="goToOrderDetail(user.order_no)">
                    <div class="card-header">
                      <span class="card-number">{{ index + 1 }}</span>
                      <span class="card-nickname">{{ user.nickname || '-' }}</span>
                    </div>
                    <div class="card-content">
                      <div class="card-item">
                        <span class="card-label">活动名称：</span>
                        <span class="card-value">{{ user.activity_title || '-' }}</span>
                      </div>
                      <div class="card-item">
                        <span class="card-label">报名时间：</span>
                        <span class="card-value">{{ formatDateTime(user.created_at) }}</span>
                      </div>
                      <div class="card-item">
                        <span class="card-label">订单号：</span>
                        <span class="card-value">{{ user.order_no || '-' }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="empty-placeholder">暂无被邀请人</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="#" type="index" width="40" align="center"></el-table-column>
        <el-table-column label="推荐码" prop="code" width="150" align="center"></el-table-column>
        <el-table-column label="推荐人/机构" prop="referrer_name" align="center"></el-table-column>
        <el-table-column label="兑换金额" prop="discount_amount" width="100" align="center">
          <template slot-scope="scope">
            {{ formatPrice(scope.row.discount_amount) }}
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="type" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 1 ? 'primary' : scope.row.type === 2 ? 'success' : 'warning'" size="small">
              {{ formatType(scope.row.type) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="推荐次数" prop="count" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.count || 0 }}次
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-tooltip content="编辑" placement="top" effect="dark" :enterable="false">
              <el-button size="mini" icon="el-icon-edit" type="primary" @click="editInvite(scope.row)"></el-button>
            </el-tooltip>
            <el-tooltip content="导出" placement="top" effect="dark" :enterable="false">
              <el-button size="mini" icon="el-icon-download" type="success" @click="exportReferral(scope.row.code)"></el-button>
            </el-tooltip>
            <el-tooltip content="删除" placement="top" effect="dark" :enterable="false">
              <el-button size="mini" icon="el-icon-delete" type="danger" @click="deleteInvite(scope.row.referral_code_id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10,20,50,100]"
          :page-size="pageSize"
          :layout="isMobile ? 'total, sizes, prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 创建/编辑推荐码对话框 -->
    <el-dialog :title="editDialogType === 'add' ? '创建推荐码' : '编辑推荐码'" :visible.sync="showAddDialog" width="450px" @close="resetForm" :body-style="{padding:'20px', maxHeight: '420px', overflowY: 'auto'}">
      <el-form :model="form" :rules="formRules" ref="inviteForm" label-width="110px">
        <el-form-item label="专属推荐码" prop="code" class="dialog-form-item">
          <el-input v-model="form.code" size="medium" :maxlength="16" :readonly="true">
            <el-button v-if="editDialogType === 'add'" slot="append" icon="el-icon-refresh" size="mini" @click="generateCode" :loading="generating">生成推荐码</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="推荐方名称" prop="referrer_name" class="dialog-form-item">
          <el-input v-model="form.referrer_name" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="推荐方类型" prop="type" class="dialog-form-item">
          <el-select v-model.number="form.type" size="medium" style="width: 100%;">
            <el-option label="个人" :value="1"></el-option>
            <el-option label="机构" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="折扣金额" prop="discount_amount" class="dialog-form-item">
          <el-input-number v-model="form.discount_amount" :min="0" :precision="2" style="width: 100%;" size="medium"></el-input-number>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" class="dialog-form-item">
          <el-input v-model="form.phone" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark" class="dialog-form-item">
          <el-input v-model="form.remark" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddDialog = false">取 消</el-button>
        <el-button type="primary" @click="editDialogType === 'add' ? addInvite() : updateInvite()" :loading="submitting">
          {{ editDialogType === 'add' ? '创 建' : '确 定' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Inviters',
  data() {
    return {
      isSearchExpanded: false,
      isMobile: false,
      inviteCodeList: [],
      searchQuery: {
        code: '',
        referrer_name: '',
        type: null
      },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      showAddDialog: false,
      editDialogType: 'add',
      submitting: false,
      generating: false,
      form: {
        referral_code_id: null,
        code: '',
        type: null,
        referrer_name: '',
        phone: '',
        remark: '',
        discount_amount: 0
      },
      formRules: {
        code: [{required: true, message: '请生成推荐码', trigger: 'blur'}],
        type: [{required: true, message: '请选择推荐人类型', trigger: 'change'}],
        referrer_name: [{required: true, message: '请输入推荐人或机构名称', trigger: 'blur'}],
        phone: [
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        discount_amount: [{required: true, message: '请输入折扣金额', trigger: 'blur'}]
      }
    };
  },
  created() {
    this.checkIsMobile();
    this.fetchInviteCodes();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 跳转到订单详情页面
    goToOrderDetail(orderId) {
      this.$router.push(`/admin/order/details/${orderId}`)
    },

    // 获取推荐码列表
    fetchInviteCodes() {
      // 过滤掉空值（null, undefined, ''）
      const queryParams = {};
      Object.keys(this.searchQuery).forEach(key => {
        const value = this.searchQuery[key];
        if (value !== null && value !== undefined && value !== '') {
          queryParams[key] = value;
        }
      });
      
      const params = {
        page: this.pageNum,
        size: this.pageSize,
        ...queryParams
      };
      this.$http({ method: 'get', url: 'referral-codes', params })
        .then(res => {
          if (!res.success) return this.$message.error(res.message)
          this.inviteCodeList = (res.data || []).map(row => {
            row.count = (row.referred_users && row.referred_users.length) || 0
            return row
          })
          this.total = res.total || 0
          this.fetchUserInfos()
        })
        .catch(err => {
          this.$message.error(err.response?.data?.message || '获取推荐码列表失败')
        })
    },
    
    handleSearch() {
      this.pageNum = 1;
      this.fetchInviteCodes();
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.pageNum = 1;
      this.fetchInviteCodes();
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage;
      this.fetchInviteCodes();
    },
    
    openAddDialog() {
      this.resetForm();
      this.editDialogType = 'add';
      this.showAddDialog = true;
    },
    
    // 生成推荐码
    generateCode() {
      this.generating = true
      this.$http({ method: 'post', url: 'referral-codes/generate' }).then(res => {
        this.generating = false
        if (!res.success) return this.$message.error(res.message || '生成推荐码失败')
        if (res.data && res.data.code) {
          this.form.code = res.data.code
          this.$message.success('推荐码生成成功')
        } else {
          this.$message.error('生成推荐码失败：未返回推荐码')
        }
      }).catch(err => {
        this.generating = false
        this.$message.error(err.response?.data?.message || '生成推荐码失败')
      })
    },
    
    // 创建推荐码
    addInvite() {
      this.$refs.inviteForm.validate(valid => {
        if (!valid) return
        
        if (!this.form.code) {
          this.$message.warning('请先点击"生成推荐码"按钮生成推荐码')
          return
        }
        
        this.$http({ method: 'post', url: 'referral-codes', data: this.form }).then(res => {
          if (!res.success) return this.$message.error(res.message)
          this.$message.success('创建推荐码成功')
          this.showAddDialog = false
          this.fetchInviteCodes()
        }).catch(err => {
          this.$message.error(err.response?.data?.message || '创建推荐码失败')
        })
      })
    },
    
    editInvite(row) {
      this.form = {
        referral_code_id: row.referral_code_id,
        code: row.code,
        type: row.type || null,
        referrer_name: row.referrer_name,
        phone: row.phone || '',
        remark: row.remark || '',
        discount_amount: row.discount_amount || 0
      };
      this.editDialogType = 'edit';
      this.showAddDialog = true;
    },
    
    updateInvite() {
      this.$refs.inviteForm.validate(valid => {
        if (!valid) return
        this.$http({ method: 'put', url: `referral-codes/${this.form.referral_code_id}`, data: this.form }).then(res => {
          if (!res.success) return this.$message.error(res.message)
          this.$message.success('更新推荐码成功')
          this.showAddDialog = false
          this.fetchInviteCodes()
        }).catch(err => {
          this.$message.error(err.response?.data?.message || '更新推荐码失败')
        })
      })
    },

    // 工具函数：生成唯一短时间戳+随机码
    shortUniqueCode() {
      const ts = Date.now().toString().slice(-5)
      const rand = Math.random().toString(36).slice(-2).toUpperCase()
      return ts + rand
    },

    // 工具函数：清理文件名中的特殊字符
    sanitizeFileName(name) {
      return name.replace(/[\\/:*?"<>|\n\r]/g, '').trim()
    },

    // 导出推荐码数据
    exportReferral(code) {
      this.$http({
        method: 'get',
        url: `referral-codes/export/${code}`,
        responseType: 'blob'
      }).then(res => {
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        link.href = url
        const uniqueCode = this.shortUniqueCode()
        const cleanCode = this.sanitizeFileName(code)
        link.download = `推荐码_${cleanCode}_数据_${uniqueCode}.xlsx`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      }).catch(err => {
        this.$message.error(err.response?.data?.message || '导出失败')
      })
    },

    deleteInvite(referralCodeId) {
      this.$confirm('此操作将永久删除该推荐码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({ method: 'delete', url: `referral-codes/${referralCodeId}` }).then(res => {
          if (!res.success) return this.$message.error(res.message)
          this.$message.success('删除推荐码成功')
          this.fetchInviteCodes()
        }).catch(err => {
          this.$message.error(err.response?.data?.message || '删除推荐码失败')
        })
      }).catch(() => {})
    },
    
    toggleSearch() {
      this.isSearchExpanded = !this.isSearchExpanded
    },

    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },

    handleResize() {
      this.checkIsMobile();
    },

    resetForm() {
      this.editDialogType = 'add';
      this.submitting = false;
      this.generating = false;
      this.$nextTick(() => {
        if (this.$refs.inviteForm) {
          this.$refs.inviteForm.resetFields();
        }
        this.form = {
          referral_code_id: null,
          code: '',
          type: null,
          referrer_name: '',
          phone: '',
          remark: '',
          discount_amount: 0
        };
      });
    },
    
    // 格式化价格显示
    formatPrice(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return '¥0.00';
      }
      const num = parseFloat(amount);
      if (isNaN(num)) {
        return '¥0.00';
      }
      return `¥${num.toFixed(2)}`;
    },
    
    // 格式化日期时间
    formatDateTime(date) {
      if (!date) return '-';
      return new Date(date).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    },
    
    // 格式化类型显示
    formatType(type) {
      if (type === 1) return '个人';
      if (type === 2) return '机构';
      if (type === 3) return '非他人推荐';
      return '-';
    },
    
    // 获取创建人名称
    getCreatorName(row) {
      if (row.created_by_info) {
        return row.created_by_info.username || row.created_by_info.name || row.created_by || null;
      }
      if (row.created_by) {
        return row.created_by;
      }
      return null;
    },
    
    // 批量获取用户信息
    async fetchUserInfos() {
      // 找出所有需要获取用户信息的记录
      const needFetchList = this.inviteCodeList.filter(row => row.created_by && !row.created_by_info);
      if (needFetchList.length === 0) return;
      
      // 收集所有需要获取的 userId（去重）
      const userIds = [...new Set(needFetchList.map(row => row.created_by))];
      
      // 批量获取用户信息
      const userInfoPromises = userIds.map(userId => 
        this.$http.get(`users/${userId}`)
          .then(res => ({ userId, userInfo: res.data }))
          .catch(err => {
            console.error(`获取用户信息失败 (userId: ${userId}):`, err);
            return { userId, userInfo: null };
          })
      );
      
      try {
        const results = await Promise.all(userInfoPromises);
        
        // 创建 userId 到 userInfo 的映射
        const userInfoMap = {};
        results.forEach(({ userId, userInfo }) => {
          if (userInfo) {
            userInfoMap[userId] = userInfo;
          }
        });
        
        // 更新每行的 created_by_info
        needFetchList.forEach(row => {
          if (userInfoMap[row.created_by]) {
            this.$set(row, 'created_by_info', userInfoMap[row.created_by]);
          }
        });
      } catch (err) {
        console.error('批量获取用户信息失败:', err);
      }
    }
  }
};
</script>

<style scoped>
.el-card {
  margin-top: 15px;
}
.el-input :deep(.el-input__inner),
.el-input__inner {
  font-family: inherit;
  font-size: 16px;
  height: 38px;
}
.dialog-form-item {
  margin-bottom: 18px !important;
}
.el-dialog__body {
  padding-top: 12px !important;
  padding-bottom: 2px !important;
}

.search-wrapper {
  margin-bottom: 10px;
}

.search-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.3s;
}

.search-toggle:hover {
  color: #409eff;
}

.search-toggle i {
  font-size: 14px;
}

.search-content {
  padding-top: 10px;
}

.search-content-mobile {
  padding-top: 10px;
}

.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-scroll-wrapper .el-table {
  min-width: 100%;
}

.pagination-wrapper {
  margin-top: 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
}

.pagination-wrapper .el-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 10px 0;
  min-width: max-content;
}

@media (max-width: 768px) {
  .el-card {
    margin-top: 10px;
    padding: 10px;
  }

  .el-table {
    font-size: 11px;
    overflow-x: auto;
    display: block;
  }

  .el-table th,
  .el-table td {
    padding: 8px 5px !important;
  }

  .el-table .el-button--mini {
    font-size: 10px;
  }

  .el-pagination {
    font-size: 11px;
  }

  .el-pagination .el-pagination__sizes {
    display: none;
  }

  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    width: 30px;
    height: 30px;
    line-height: 30px;
  }

  .el-pagination .el-pager li {
    padding: 0 4px;
    min-width: 28px;
    height: 30px;
    line-height: 30px;
  }

  .search-content .el-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .search-content .el-row .el-col {
    width: 100% !important;
    margin-bottom: 5px;
  }

  .search-toggle {
    padding: 10px 0;
    font-size: 13px;
  }

  .el-dialog {
    width: 95% !important;
    margin: 0 auto;
    top: 5vh;
  }

  .expand-content {
    padding: 10px;
  }

  .basic-info {
    flex-direction: row;
    gap: 10px;
    align-items: flex-start;
  }

  .info-left,
  .info-right {
    flex-direction: row;
    gap: 5px;
  }

  .invited-cards {
    grid-template-columns: 1fr;
  }

  .invited-card {
    padding: 8px 10px;
  }

  .card-header {
    margin-bottom: 6px;
    padding-bottom: 6px;
  }

  .card-number {
    width: 18px;
    height: 18px;
    font-size: 10px;
  }

  .card-nickname {
    font-size: 12px;
  }

  .card-item {
    font-size: 11px;
  }

  .card-label {
    min-width: 55px;
  }
}
.expand-content {
  padding: 12px;
}
.basic-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}
.info-left {
  display: flex;
  gap: 20px;
  align-items: center;
}
.info-right {
  display: flex;
  gap: 20px;
  align-items: center;
}
.info-text {
  display: inline-block;
  font-size: 13px;
  color: #606266;
  line-height: 1.8;
}
.info-right .info-text {
  margin-right: 0;
}
.invited-list {
  margin-top: 10px;
}
.list-title {
  font-size: 12px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: 500;
}
.invited-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
}
.invited-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 10px 12px;
  transition: all 0.3s ease;
}
.invited-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  border-color: #409eff;
}
.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
}
.card-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: #409eff;
  color: #fff;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}
.card-nickname {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}
.card-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.card-item {
  display: flex;
  align-items: flex-start;
  font-size: 12px;
  line-height: 1.5;
}
.card-label {
  color: #909399;
  min-width: 65px;
  flex-shrink: 0;
}
.card-value {
  color: #606266;
  flex: 1;
  word-break: break-all;
}
.empty-placeholder {
  padding: 40px 10px;
  text-align: center;
  color: #999;
  font-size: 13px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #e9ecef;
}
</style>
